import React from 'react'

const OperationsContext = React.createContext(null)

export const Provider = OperationsContext.Provider
export const Consumer = OperationsContext.Consumer

export default OperationsContext
